import { useEffect, useMemo, useRef, useCallback } from 'react'

import { QRCodeWrapper, CardWrapper, CardText, CardContent, CardLink, Card, CardQrCodeWrapper } from './Styled'
import QRCode from 'qrcode.react'
import { BeatLoader } from 'react-spinners'
import { useHtml2Image } from 'hooks/useHtml2Image'

interface ShareCardProps {
  url?: string
}

export default function SharePage({ url }: ShareCardProps) {
  const cardRef = useRef<HTMLDivElement>(null)
  const { downloadHtmlAsImage } = useHtml2Image()

  const link = useMemo(() => {
    return url ? url : ''
  }, [url])

  const handleDownload = useCallback(
    async function () {
      try {
        await downloadHtmlAsImage(cardRef.current, 'share_card', { backgroundColor: null, scale: 2 })
      } catch (ex) {
        console.warn('download image error', ex)
      }
    },
    [downloadHtmlAsImage]
  )

  useEffect(() => {
    setTimeout(() => {
      handleDownload()
    }, 1000)
  }, [handleDownload])

  return (
    <CardWrapper>
      <Card ref={cardRef}>
        <CardContent>
          <CardQrCodeWrapper>
            <QRCodeWrapper>
              {!!link ? (
                <QRCode id={'qrcode'} style={{ width: '2.64rem', height: '2.64rem' }} value={link} level={'H'} />
              ) : (
                <BeatLoader size={10} />
              )}
            </QRCodeWrapper>
          </CardQrCodeWrapper>
          <CardText>
            <div>
              扫描二维码
              <br />
              下载APP立即观看
            </div>
            <CardLink>{link}</CardLink>
          </CardText>
        </CardContent>
      </Card>
    </CardWrapper>
  )
}
